let analytics = require('../../actions/analytics');
module.exports = {
    raiseEventsOnOrderLoaded: [
        [
            analytics.fillEventOnOrderLoaded,
            {
                filled: [analytics.raiseArgsValueEvent],
                noEvent: []
            }
        ],
        [
            analytics.fillEventIfBillAttached,
            {
                filled: [analytics.raiseArgsValueEvent],
                noEvent: []
            }
        ]
    ]
};



// WEBPACK FOOTER //
// ./signals/groups/analytics.js